// Bootstrap entry point for the solui Angular app.
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { register as swiperRegisterElements } from 'swiper/element/bundle';

import { environment } from '@ts/shared/util-environment';

import { AppModule } from './app/app.module';

if (environment.production) {
  enableProdMode();
}

swiperRegisterElements();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
